"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseApiService_1 = require("../apiServices/baseApiService/BaseApiService");
var Url_1 = require("./Url");
var axios_1 = tslib_1.__importDefault(require("axios"));
var lodash_1 = require("lodash");
var DataBuilder_1 = require("../builder/DataBuilder");
var string_format_1 = tslib_1.__importDefault(require("string-format"));
var ModelConstants_1 = require("../constants/ModelConstants");
string_format_1.default.extend(String.prototype, {});
var payload = function (model) {
    return {
        "filters": [
            {
                "name": "model",
                "condition": "string",
                "value": model
            }
        ]
    };
};
var GetTypeDetails = function (model, typeId, version) {
    return Url_1.url.TypeDefinitionsUrl + model + '/types/' + typeId + '/versions/' + version;
};
var GetTenantBasedTypeDetails = function (model, typeId, version) {
    return Url_1.url.TypeDefinitionsUrl + model + '/types/' + typeId + '/versions/' + version;
};
var GetVersions = function (model, typeId) {
    return Url_1.url.TypeDefinitionsUrl + model + '/types/' + typeId + '/versions';
};
var GetDeletedTypeVersions = function (model, typeId) {
    return Url_1.url.TypeDefinitionsUrl + model + '/types/' + typeId + '/versions?includeDeleted=true';
};
var Types = /** @class */ (function () {
    function Types() {
    }
    Types.prototype.getTypes = function (models, source) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var responses, results, types, apiResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        responses = lodash_1.map(models, function (model) {
                            var url = "" + Url_1.url.ModelTypesUrl;
                            return BaseApiService_1.BaseApiService.post(url, payload(model), source);
                        });
                        return [4 /*yield*/, axios_1.default.all(responses)];
                    case 1:
                        results = _a.sent();
                        types = new Array();
                        lodash_1.map(results, function (result) {
                            types = types.concat(DataBuilder_1.DataBuilder.buildType(result.data));
                        });
                        apiResponse = {
                            status: results[0].status,
                            data: types
                        };
                        return [2 /*return*/, apiResponse];
                }
            });
        });
    };
    Types.prototype.getTypeDetails = function (model, typeId, version, source) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BaseApiService_1.BaseApiService.get(GetTypeDetails(model, typeId, version), source)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Types.prototype.getTypeVariables = function (model, typeId, version, source) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.TypeDefinitionBase + ("/models/" + model + "/types/" + typeId + "/versions/" + version + "/variables");
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url, source)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Types.prototype.getTenantBasedTypeDetails = function (model, typeId, version, source) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BaseApiService_1.BaseApiService.get(GetTenantBasedTypeDetails(model, typeId, version), source)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Types.prototype.saveType = function (type, model) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.TypeDefinitionsUrl + model + '/types';
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, type)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Types.prototype.deleteType = function (typeId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.TypeDefinitionsUrl + modelId + '/types/' + typeId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.delete(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Types.prototype.getTypeVersions = function (model, typeId, includeDeleted) {
        if (includeDeleted === void 0) { includeDeleted = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = includeDeleted ? GetDeletedTypeVersions(model, typeId) : GetVersions(model, typeId);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.getLatestType = function (model, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.TypeDefinitionsUrl + model + "/types/" + typeId;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.verifyModelUniqueness = function (model, typeId, version, additionalModel) {
        if (additionalModel === void 0) { additionalModel = undefined; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hasVersion, result, response, _a, response;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        hasVersion = false;
                        result = {
                            isUnique: false,
                            isDeleted: false
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this.getTypeVersions(model, typeId, true)];
                    case 2:
                        response = _b.sent();
                        hasVersion = lodash_1.includes(response.data.versions, version);
                        if (hasVersion) {
                            result.isDeleted = response.data.isDeleted;
                            return [2 /*return*/, result];
                        }
                        else {
                            result.isDeleted = response.data.isDeleted;
                            result.isUnique = true;
                            return [2 /*return*/, result];
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _b.sent();
                        if (!additionalModel) {
                            result.isUnique = true;
                            return [2 /*return*/, result];
                        }
                        return [4 /*yield*/, this.getTypeVersions(additionalModel, typeId, true).catch(function (error) {
                                return undefined;
                            })];
                    case 4:
                        response = _b.sent();
                        if (!response) {
                            result.isUnique = true;
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/, result];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Types.prototype.postModelDefinition = function (modelJson) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(Url_1.url.ModelDefinitionUrl, modelJson)];
            });
        });
    };
    Types.prototype.getModelDefinition = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.TypeDefinitionsUrl + modelId;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.getSupportedCondintionModelList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.GetSupportedCondintionModelList;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.addSupportedModels = function (modelList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(Url_1.url.AddConditionMonitorSupportedModels, modelList)];
            });
        });
    };
    Types.prototype.updateConditionMonitorModels = function (modelList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(Url_1.url.UpdateConditionMonitorSupportedModels, modelList)];
            });
        });
    };
    Types.prototype.removeConditionMonitorModels = function (modelIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.RemoveConditionMonitorSupportedModels);
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(url, modelIds)];
            });
        });
    };
    Types.prototype.getFunctionVersionsForType = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.FunctionVersions, modelId, typeId, version);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.getLatestFunctionsForType = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.TypeLatestFunctions, modelId, typeId, version);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.getAssetMonitorTypesInfoForGivenFunctionType = function (typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.GetAMTypesForFunction, typeId, version);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.verifyTypeExists = function (modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.VerifyTypeExists, modelId, typeId);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.getModelsAndTypesBySCEModelIdWithTypeInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.GetModelsAndTypesBySCEModelIdWithTypeInfo, ModelConstants_1.ModelConstants.SceModel);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.getVariablesAlarmsAndEvents = function (modelId, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = string_format_1.default(Url_1.url.GetVariablesAlarmsAndEvents, modelId, typeId, version);
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.getAllModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.GetAllModels;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.getFunctionEndpointList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.GetFunctionEndpointList;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Types.prototype.addFunctionEndpoint = function (endPoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.AddFunctionEndpoint;
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(url, endPoint)];
            });
        });
    };
    Types.prototype.deleteFunctionEndpoint = function (endPoint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.DeleteFunctionEndpoint;
                return [2 /*return*/, BaseApiService_1.BaseApiService.post(url, endPoint)];
            });
        });
    };
    Types.prototype.getEnggsSceModels = function (models, source) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.GetEnggSceModels;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, models, source)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return Types;
}());
exports.Types = Types;
//# sourceMappingURL=Types.js.map